import { jsx as _jsx } from "react/jsx-runtime";
import Text from '@jetbrains/ring-ui/components/text/text';
import { BasePluginRule } from '@app/pages/profiles/profile-details/profile-ide-provisioner/plugin-rules/bundles/base-plugin-rule/base-plugin-rule';
export function AllPluginsRule({ rule, className }) {
    return (_jsx(BasePluginRule, { rule: rule, className: className, children: _jsx(Text, { bold: true, children: "All Plugins" }) }));
}
